export default __webpack_public_path__ + "static/renting-property-d-af4627b16e13981daa50b46348df5173.png";